






























































































































































































































































































































































































import { Vue, Component, Prop, Ref, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { storePasien } from "@/store/modules/pasien";
import { refResepStore } from "@/store/modules/ReferensiResep";
import ObatSearchBox from "@/components/resep/ObatSearchBox.vue";
import ObatItemTerstrukturRow from "@/components/resep/ObatItemTerstrukturRow.vue";
import RacikanTerstrukturRow from "@/components/resep/RacikanTerstrukturRow.vue";
import RiwayatObatPanel from "@/components/resep/RiwayatObatPanel.vue";
import ResepRalanUnifiedSvc, { Regimen } from "@/services/ResepRalanUnified";
import ResepTerstrukturSvc from "@/services/ResepTerstruktur";
import {
  BarisResepTerstruktur,
  KonteksAptol,
  KonteksBatasJkn,
  RacikanTerstruktur,
  barisBaru,
  barisKePayload,
  racikanKePayload,
  barisDariItemResep,
  cocokAlergi,
  masalahBaris,
  masalahAptol,
  masalahJkn,
  masalahRacikan,
  nomorRacikanBerikut,
  racikanBaru,
  racikanDariResep,
  statusBatasJkn
} from "@/utils/resepTerstruktur";
import { barisDariRiwayatObat } from "@/utils/riwayatObat";
import { barisRDariTeks } from "@/utils/tempelResep";
import {
  barisDariTemplate,
  racikanDariTemplate,
  ringkasTemplate
} from "@/utils/templateResep";
import { RiwayatObatEntri } from "@/types/riwayat_obat";
import { debounce } from "lodash";

type BarisModal = BarisResepTerstruktur & { _kunci: number };

let kunciBaris = 0;

@Component({
  components: {
    ObatSearchBox,
    ObatItemTerstrukturRow,
    RacikanTerstrukturRow,
    RiwayatObatPanel
  },
  inject: { isReadOnly: { default: () => () => false } }
})
export default class CardResepTerstrukturInput extends Vue {
  @Prop({ default: () => [] }) items!: any[];
  @Prop({ type: Boolean, default: false }) showed!: boolean;
  @Prop({ default: () => [] }) racikan!: any[];
  @Prop({ type: Boolean, default: false }) wajib!: boolean;
  @Prop({ type: Boolean, default: false }) saving!: boolean;
  @Prop({ default: null }) rm!: string | number | null;
  @Prop({ default: null }) registerId!: string | number | null;
  @Prop({ default: "" }) unitId!: string;
  @Prop({ default: null }) resepId!: number | null;
  @Prop({ default: null }) tempelan!: {
    label: string;
    teks: string | null;
  } | null;
  @Prop({ required: true }) form!: {
    depo_id: string;
    bb: any;
    alergi: string;
    diagnosis: string;
    doctor_note: string;
  };
  @Prop({ default: () => [] }) depoList!: Array<{
    text: string;
    value: string;
  }>;

  @Ref() readonly obatSearchBox!: any;

  isReadOnly!: () => boolean;
  get readOnly(): boolean {
    return this.isReadOnly();
  }

  baris: BarisModal[] = [];
  daftarRacikan: RacikanTerstruktur[] = [];
  batasJkn: KonteksBatasJkn | null = null;
  aptol: KonteksAptol | null = null;
  kirimLangsung = true;
  tampilRiwayat = true;
  showSimpanTemplate = false;
  namaTemplate = "";
  galatTemplate = "";
  menyimpanTemplate = false;
  sudahDicoba = false;
  showRegimenPicker = false;
  regimenSearch = "";
  regimenScope: "personal" | "all" = "personal";
  regimenList: Regimen[] = [];
  searchRegimen = debounce(() => this.loadRegimens(), 350);

  get panelRiwayatTampil(): boolean {
    return !!this.rm && this.tampilRiwayat;
  }

  get obatTerpakai(): string[] {
    return this.baris
      .map(item => item.obat_id)
      .filter((id): id is string => !!id);
  }

  get jumlahEntri() {
    return this.baris.length + this.daftarRacikan.length;
  }

  get pasien() {
    const ident = storePasien.identitasPasien || ({} as any);
    return {
      nama: ident.nama || "—",
      nrm: ident.rm || ident.cm || "—",
      umur: ident.umur || ""
    };
  }

  mounted() {
    this.pastikanReferensi();
    if (this.showed) {
      this.siapkan();
    }
  }

  pastikanReferensi() {
    if (!refResepStore.refRute || refResepStore.refRute.length === 0) {
      refResepStore.getRefRute();
    }
    if (
      !refResepStore.refFrekuensi ||
      refResepStore.refFrekuensi.length === 0
    ) {
      refResepStore.getRefFrekuensi();
    }
    if (
      !refResepStore.refSatuanDosis ||
      refResepStore.refSatuanDosis.length === 0
    ) {
      refResepStore.getRefSatuanDosis();
    }
    if (
      !refResepStore.refAturanTambahan ||
      refResepStore.refAturanTambahan.length === 0
    ) {
      refResepStore.getRefAturanTambahan();
    }
    if (!refResepStore.refSediaan || refResepStore.refSediaan.length === 0) {
      refResepStore.getRefSediaan();
    }
  }

  @Watch("showed")
  berubahTampil(tampil: boolean) {
    if (tampil) {
      this.siapkan();
    }
  }

  get barisTeksTempelan() {
    return this.tempelan ? barisRDariTeks(this.tempelan.teks) : [];
  }

  cariDariTeks(kataKunci: string) {
    if (this.obatSearchBox && this.obatSearchBox.cari) {
      this.obatSearchBox.cari(kataKunci);
    }
  }

  async muatBatasJkn() {
    const registerId = this.registerId;
    const unitId = this.unitId;
    const resepId = this.resepId;
    this.batasJkn = null;
    if (!registerId || !unitId) return;
    const konteks = await ResepTerstrukturSvc.batasJkn(
      registerId,
      unitId,
      resepId
    );
    if (
      this.showed &&
      registerId === this.registerId &&
      unitId === this.unitId &&
      resepId === this.resepId
    ) {
      this.batasJkn = konteks;
    }
  }

  async muatAptol() {
    const registerId = this.registerId;
    this.aptol = null;
    if (!registerId) return;
    const konteks = await ResepTerstrukturSvc.aptol(registerId);
    if (this.showed && registerId === this.registerId) {
      this.aptol = konteks;
    }
  }

  get spandukAptol(): string {
    const a = this.aptol;
    if (!a || !a.aktif) return "";
    if (a.status === "UNAVAILABLE" || a.status === "TANPA_NOKA") {
      return a.pesan || "Riwayat Apotek Online BPJS tidak dapat dicek.";
    }
    return "";
  }

  terpakaiJknLain(item: BarisModal): number {
    const kode = String(item.obat_id || "")
      .trim()
      .toUpperCase();
    return this.baris.reduce((jumlah, lain) => {
      if (
        lain._kunci === item._kunci ||
        String(lain.obat_id || "")
          .trim()
          .toUpperCase() !== kode
      ) {
        return jumlah;
      }
      const qty = Number(String(lain.qty ?? "").replace(",", "."));
      return isFinite(qty) && qty > 0 ? jumlah + qty : jumlah;
    }, 0);
  }

  siapkan() {
    this.sudahDicoba = false;
    this.muatBatasJkn();
    this.muatAptol();
    const label = this.tempelan ? this.tempelan.label : null;
    this.baris = (this.items || []).map(item =>
      this.denganKunci({ ...barisDariItemResep(item), _disalin: label })
    );
    this.daftarRacikan = (this.racikan || []).map(racikanDariResep);
    this.$nextTick(() => this.$nextTick(() => this.fokusPencarian()));
  }

  denganKunci(item: BarisResepTerstruktur): BarisModal {
    return { ...item, _kunci: ++kunciBaris };
  }

  fokusPencarian() {
    if (this.obatSearchBox && this.obatSearchBox.focus) {
      this.obatSearchBox.focus();
    }
  }

  tambahObat(obat: any) {
    if (cocokAlergi(this.form.alergi, obat.nama)) {
      const lanjut = confirm(
        `PERHATIAN — pasien memiliki alergi "${this.form.alergi}" dan obat yang dipilih (${obat.nama}) mungkin terkait. Tetap tambahkan?`
      );
      if (!lanjut) return;
    }

    this.baris.push(
      this.denganKunci(
        barisBaru({
          obat_id: obat.id,
          obat_nama: obat.nama,
          qty_unit: obat.satuan,
          harga: obat.harga,
          _fokus: true
        })
      )
    );
  }

  salinDariRiwayat(entri: RiwayatObatEntri) {
    if (this.readOnly || this.obatTerpakai.includes(entri.obat_id)) return;

    if (cocokAlergi(this.form.alergi, entri.obat_nama)) {
      const lanjut = confirm(
        `PERHATIAN — pasien memiliki alergi "${this.form.alergi}" dan obat yang disalin (${entri.obat_nama}) mungkin terkait. Tetap tambahkan?`
      );
      if (!lanjut) return;
    }

    this.baris.push(this.denganKunci(barisDariRiwayatObat(entri)));
  }

  hapusBaris(idx: number) {
    this.baris.splice(idx, 1);
  }

  tambahRacikan() {
    const nomor = nomorRacikanBerikut(this.daftarRacikan);
    this.daftarRacikan.push(
      racikanBaru({ r: `r${nomor}`, nama: `Racikan ${nomor}`, _fokus: true })
    );
  }

  hapusRacikan(idx: number) {
    this.daftarRacikan.splice(idx, 1);
  }

  submitItems() {
    if (this.readOnly || this.saving) return;

    this.sudahDicoba = true;

    const masalah: string[] = [];
    if (!this.form.depo_id) masalah.push("Depo wajib dipilih");
    if (!this.form.diagnosis) masalah.push("Diagnosis wajib diisi");
    this.baris.forEach(item => {
      const pesan =
        masalahBaris(item) ||
        masalahJkn(
          item,
          statusBatasJkn(item, this.batasJkn, this.terpakaiJknLain(item)),
          this.batasJkn
        ) ||
        masalahAptol(item, this.aptol);
      if (pesan) masalah.push(pesan);
    });
    this.daftarRacikan.forEach(racikan => {
      const pesan = masalahRacikan(racikan);
      if (pesan) masalah.push(pesan);
    });

    if (masalah.length) {
      appModule.sendErrorAlert(
        "Belum lengkap:<br/>" + masalah.slice(0, 6).join("<br/>")
      );
      return;
    }

    this.$emit("simpan", {
      items: this.baris,
      racikan: this.daftarRacikan,
      kirim: this.kirimLangsung
    });
  }

  close() {
    this.baris = [];
    this.daftarRacikan = [];
    this.$emit("close");
  }

  openRegimenPicker() {
    this.showRegimenPicker = true;
    this.loadRegimens();
  }

  async loadRegimens() {
    try {
      this.regimenList = await ResepRalanUnifiedSvc.regimenFast({
        q: this.regimenSearch || "",
        scope: this.regimenScope
      });
    } catch (e) {
      this.regimenList = [];
    }
  }

  regimenSummary(r: Regimen): string {
    return ringkasTemplate(r);
  }

  applyRegimen(r: Regimen) {
    const terpakai = new Set(this.obatTerpakai);
    const baru = barisDariTemplate(r).filter(
      item => item.obat_id && !terpakai.has(item.obat_id)
    );
    const racikan = racikanDariTemplate(r);
    const alergi = [
      ...baru.map(item => item.obat_nama),
      ...racikan.flatMap(rc => rc.komponen.map(k => k.obat_nama))
    ].filter(nama => cocokAlergi(this.form.alergi, nama));

    if (alergi.length) {
      const lanjut = confirm(
        `PERHATIAN — pasien memiliki alergi "${
          this.form.alergi
        }" dan template berisi obat yang mungkin terkait (${alergi.join(
          ", "
        )}). Tetap terapkan?`
      );
      if (!lanjut) return;
    }

    baru.forEach(item => {
      this.baris.push(
        this.denganKunci({ ...item, _disalin: `Dari template "${r.nama}"` })
      );
    });

    racikan.forEach(rc => {
      const nomor = nomorRacikanBerikut(this.daftarRacikan);
      this.daftarRacikan.push({
        ...rc,
        r: `r${nomor}`,
        nama: /^Racikan \d+$/.test(rc.nama || "") ? `Racikan ${nomor}` : rc.nama
      });
    });

    this.showRegimenPicker = false;
    appModule.sendSuccessNotice(`Template "${r.nama}" diterapkan`);
    appModule.closeNoticeWithDelay();
  }

  bukaSimpanTemplate() {
    this.namaTemplate = "";
    this.galatTemplate = "";
    this.showSimpanTemplate = true;
  }

  async simpanTemplate() {
    if (this.menyimpanTemplate) return;

    const nama = this.namaTemplate.trim();
    if (!nama) {
      this.galatTemplate = "Nama template wajib diisi";
      return;
    }

    const masalah = [
      ...this.baris.map(item => masalahBaris(item)),
      ...this.daftarRacikan.map(rc => masalahRacikan(rc))
    ].filter(Boolean);
    if (masalah.length) {
      this.galatTemplate = `Lengkapi resep dulu: ${masalah[0]}`;
      return;
    }

    const racikan = this.daftarRacikan.map(racikanKePayload);
    this.menyimpanTemplate = true;
    this.galatTemplate = "";

    try {
      await ResepRalanUnifiedSvc.simpanTemplate({
        nama,
        text: "",
        items: [
          ...this.baris.map(item => ({ ...barisKePayload(item), id: null })),
          ...racikan.flatMap(rc => rc.komponen.map(k => ({ ...k, id: null })))
        ],
        racikan: racikan.map(rc => ({ ...rc.header, id: null }))
      });
      this.showSimpanTemplate = false;
      appModule.sendSuccessNotice(`Template "${nama}" tersimpan`);
      appModule.closeNoticeWithDelay();
    } catch (e) {
      this.galatTemplate = "Template gagal disimpan — coba lagi.";
    } finally {
      this.menyimpanTemplate = false;
    }
  }
}
